import { Resource } from '../resource/resource.model';
import { NotificationSeverity } from './notification-catalog-entry.model';

export type NotificationDeliveryStatus = 'pending' | 'sent' | 'failed' | 'read';

/** One in-app feed item (GET /v1/notifications/feed). bodyJson is the event payload or the summary block. */
export class NotificationDelivery extends Resource {
  public bodyJson: string = '{}';
  public channel: string = 'in_app';
  public createdAt: Date = new Date(0);
  public eventId?: string;
  public eventType: string = '';
  public readAt?: Date;
  public reportType?: string;
  /** Set once "Retry export" has been used on this row; the button stays disabled for a minute. */
  public retriedAt?: Date;
  public severity: NotificationSeverity = 'info';
  public status: NotificationDeliveryStatus = 'sent';
  public subject: string = '';
  public windowFrom?: Date;
  public windowTo?: Date;
}
